import React from 'react';
import EnhancedStickyPhone from './EnhancedStickyPhone';

// Import zrzutów ekranu dla wersji mobilnej
import homeScreenshot from '../assets/home-screen.png';
import statsScreenshot from '../assets/stats-screen.png';
import settingsScreenshot from '../assets/settings-screen.png';
import funScreenshot from '../assets/fun-stats-screen.png';

function EnhancedLandingPage() {
  return (
    <div className="landing-page">
      {/* Navbar */}
      <nav className="navbar navbar-expand-lg navbar-light sticky-top bg-white">
        <div className="container py-3">
          <a className="navbar-brand fw-bold" href="/" style={{ fontFamily: "'Nunito', sans-serif", fontWeight: 800 }}>
            <span className="text-primary">Aim</span>
            <span className="text-warning">Fit</span>
          </a>

          <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav">
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav me-auto">
              <li className="nav-item">
                <a className="nav-link" href="#features">Features</a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#settings">Settings</a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#fun-stats">Fun Stats</a>
              </li>
            </ul>
            <a href="#download" className="btn btn-primary">Download</a>
          </div>
        </div>
      </nav>

      <div className="container">
        <div className="row">
          {/* Lewa kolumna z "przyklejonym" telefonem */}
          <div className="col-lg-5 position-relative d-none d-lg-block">
            <EnhancedStickyPhone />
          </div>

          {/* Prawa kolumna z przewijalną treścią */}
          <div className="col-lg-7">
            {/* Hero Section */}
            <section id="hero" className="min-vh-100 d-flex flex-column justify-content-center py-5">
              <div className="d-block d-lg-none text-center mb-5">
                <h5 className="text-secondary mb-3">Home Screen</h5>
                <div className="phone-mockup bg-white shadow-lg mx-auto mb-5"
                  style={{
                    width: '250px',
                    height: '500px',
                    borderRadius: '40px',
                    border: '8px solid #333',
                    overflow: 'hidden',
                    position: 'relative'
                  }}>
                  <div className="screenshot" style={{
                    height: '100%',
                    width: '100%',
                    backgroundImage: `url(${homeScreenshot})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center'
                  }}></div>
                </div>
              </div>

              <h1 className="display-4 fw-bold mb-4">
                <span className="text-primary">Focus</span> on progress, not restrictions
              </h1>
              <p className="lead mb-4">
                AimFit helps you focus on building positive habits by tracking workout calories, without obsessing over diet.
              </p>
              <div className="d-grid gap-2 d-md-flex mb-5">
                <a href="#download" className="btn btn-primary btn-lg">
                  Download Free
                </a>
                <a href="#philosophy" className="btn btn-outline-secondary btn-lg">
                  Learn Our Philosophy
                </a>
              </div>

              {/* Dodatkowa przestrzeń dla poprawnego oddzielenia sekcji */}
              <div style={{ marginBottom: '150px' }}></div>
            </section>

            {/* Features Section */}
            <section id="features" className="min-vh-100 d-flex flex-column justify-content-center py-5">
              <div className="d-block d-lg-none text-center mb-5">
                <h5 className="text-secondary mb-3">Stats Screen</h5>
                <div className="phone-mockup bg-white shadow-lg mx-auto mb-5"
                  style={{
                    width: '250px',
                    height: '500px',
                    borderRadius: '40px',
                    border: '8px solid #333',
                    overflow: 'hidden',
                    position: 'relative'
                  }}>
                  <div className="screenshot" style={{
                    height: '100%',
                    width: '100%',
                    backgroundImage: `url(${statsScreenshot})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center'
                  }}></div>
                </div>
              </div>

              <h2 className="display-5 fw-bold mb-5">
                <span className="text-primary">Simple</span> and effective approach to fitness
              </h2>

              <div className="feature-item mb-5">
                <div className="bg-primary text-white rounded-circle mb-4 d-flex align-items-center justify-content-center" style={{ width: '60px', height: '60px' }}>
                  <i className="bi bi-lightning-fill fs-4"></i>
                </div>
                <h3 className="fs-4 fw-bold mb-3">Workout Calories Only</h3>
                <p className="text-secondary">
                  We track only calories burned during workouts from Apple Health, promoting positive habit building without diet obsession. This approach helps you focus on adding activity to your life rather than restricting your diet.
                </p>
              </div>

              <div className="feature-item mb-5">
                <div className="bg-warning text-white rounded-circle mb-4 d-flex align-items-center justify-content-center" style={{ width: '60px', height: '60px' }}>
                  <i className="bi bi-graph-up fs-4"></i>
                </div>
                <h3 className="fs-4 fw-bold mb-3">Fat Energy Equivalent</h3>
                <p className="text-secondary">
                  Our unique approach translates burned calories to fat energy equivalent, helping you better understand the value of your workouts. When you burn 7700 kcal (or 3500 kcal for lbs), it's the energy equivalent stored in 1 kg (or 1 lb) of fat tissue.
                </p>
              </div>

              {/* Dodatkowa przestrzeń dla poprawnego oddzielenia sekcji */}
              <div style={{ marginBottom: '150px' }}></div>
            </section>

            {/* Settings Section */}
            <section id="settings" className="min-vh-100 d-flex flex-column justify-content-center py-5">
              <div className="d-block d-lg-none text-center mb-5">
                <h5 className="text-secondary mb-3">Settings Screen</h5>
                <div className="phone-mockup bg-white shadow-lg mx-auto mb-5"
                  style={{
                    width: '250px',
                    height: '500px',
                    borderRadius: '40px',
                    border: '8px solid #333',
                    overflow: 'hidden',
                    position: 'relative'
                  }}>
                  <div className="screenshot" style={{
                    height: '100%',
                    width: '100%',
                    backgroundImage: `url(${settingsScreenshot})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center'
                  }}></div>
                </div>
              </div>

              <h2 className="display-6 fw-bold mb-4">Flexible Goal Setting</h2>
              <p className="lead mb-4">
                Customize your fitness journey with flexible settings that adapt to your personal preferences.
              </p>
              <ul className="list-unstyled">
                <li className="mb-5 d-flex align-items-start">
                  <div className="bg-primary text-white rounded-circle p-2 me-3 mt-1" style={{width: '32px', height: '32px', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                    <i className="bi bi-toggles"></i>
                  </div>
                  <div>
                    <h5 className="fw-bold">Choose Your Goal Type</h5>
                    <p className="text-secondary">Select between calorie goals or fat energy equivalent to track your progress in the way that makes sense to you. AimFit adapts to your preferred way of thinking about fitness progress.</p>
                  </div>
                </li>
                <li className="mb-5 d-flex align-items-start">
                  <div className="bg-primary text-white rounded-circle p-2 me-3 mt-1" style={{width: '32px', height: '32px', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                    <i className="bi bi-calendar-date"></i>
                  </div>
                  <div>
                    <h5 className="fw-bold">Custom Start Date</h5>
                    <p className="text-secondary">Set your own start date to create flexible goal periods - weekly, monthly, or custom timeframes that work for your lifestyle. This makes it easy to track progress over any timeframe that suits your needs.</p>
                  </div>
                </li>
                <li className="mb-5 d-flex align-items-start">
                  <div className="bg-primary text-white rounded-circle p-2 me-3 mt-1" style={{width: '32px', height: '32px', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                    <i className="bi bi-rulers"></i>
                  </div>
                  <div>
                    <h5 className="fw-bold">Weight Unit Selection</h5>
                    <p className="text-secondary">Choose between kilograms or pounds based on your preference. AimFit automatically converts all calculations to maintain consistency with your chosen units.</p>
                  </div>
                </li>
              </ul>

              {/* Dodatkowa przestrzeń dla poprawnego oddzielenia sekcji */}
              <div style={{ marginBottom: '150px' }}></div>
            </section>

            {/* Fun Stats Section */}
            <section id="fun-stats" className="min-vh-100 d-flex flex-column justify-content-center py-5">
              <div className="d-block d-lg-none text-center mb-5">
                <h5 className="text-secondary mb-3">Fun Stats Screen</h5>
                <div className="phone-mockup bg-white shadow-lg mx-auto mb-5"
                  style={{
                    width: '250px',
                    height: '500px',
                    borderRadius: '40px',
                    border: '8px solid #333',
                    overflow: 'hidden',
                    position: 'relative'
                  }}>
                  <div className="screenshot" style={{
                    height: '100%',
                    width: '100%',
                    backgroundImage: `url(${funScreenshot})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center'
                  }}></div>
                </div>
              </div>

              <h2 className="display-6 fw-bold mb-4">Fun & Insightful Stats</h2>
              <p className="lead mb-4">
                Discover entertaining yet meaningful insights that transform boring numbers into engaging perspectives.
              </p>
              <ul className="list-unstyled">
                <li className="mb-5 d-flex align-items-start">
                  <div className="bg-primary text-white rounded-circle p-2 me-3 mt-1" style={{width: '32px', height: '32px', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                    <i className="bi bi-emoji-smile-fill"></i>
                  </div>
                  <div>
                    <h5 className="fw-bold">Food Equivalents</h5>
                    <p className="text-secondary">See your burned calories converted into chocolate bars, burgers, or broccoli pieces for a fun perspective on your achievements. This helps you visualize your progress in terms you can easily understand and relate to.</p>
                  </div>
                </li>
                <li className="mb-5 d-flex align-items-start">
                  <div className="bg-primary text-white rounded-circle p-2 me-3 mt-1" style={{width: '32px', height: '32px', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                    <i className="bi bi-lightbulb-fill"></i>
                  </div>
                  <div>
                    <h5 className="fw-bold">Activity Comparisons</h5>
                    <p className="text-secondary">Discover that your workouts equal 20 hours of singing or 10 hours of dancing - making your efforts tangible in unexpected ways. These comparisons help put your achievements into a new and motivating context.</p>
                  </div>
                </li>
                <li className="mb-5 d-flex align-items-start">
                  <div className="bg-primary text-white rounded-circle p-2 me-3 mt-1" style={{width: '32px', height: '32px', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                    <i className="bi bi-pin-map-fill"></i>
                  </div>
                  <div>
                    <h5 className="fw-bold">Distance & Landmarks</h5>
                    <p className="text-secondary">Convert your energy expenditure into distances around famous landmarks, adding a geographical dimension to your accomplishments. See how your workouts stack up against climbing the Eiffel Tower or running a marathon.</p>
                  </div>
                </li>
              </ul>

              {/* Dodatkowa przestrzeń dla poprawnego oddzielenia sekcji */}
              <div style={{ marginBottom: '150px' }}></div>
            </section>

            {/* Philosophy Section */}
            <section id="philosophy" className="min-vh-100 d-flex flex-column justify-content-center py-5">
              <h2 className="text-center display-5 fw-bold mb-5">
                Our Philosophy
              </h2>
              <p className="lead mb-4 text-center">
                AimFit is designed around a simple philosophy: adding positive habits is more sustainable than focusing on restrictions.
              </p>

              <div className="row mb-5">
                <div className="col-md-4 mb-4">
                  <div className="p-4 h-100 bg-light rounded">
                    <h4 className="fs-5 mb-3 d-flex align-items-center">
                      <span className="text-warning me-2">●</span>
                      Long-term Vision
                    </h4>
                    <p className="text-secondary mb-0">
                      "Aim" rather than "Goal" reflects our philosophy that fitness is a journey, not a destination. We help you maintain a trajectory toward better health with consistent progress.
                    </p>
                  </div>
                </div>

                <div className="col-md-4 mb-4">
                  <div className="p-4 h-100 bg-light rounded">
                    <h4 className="fs-5 mb-3 d-flex align-items-center">
                      <span className="text-primary me-2">●</span>
                      Fat Energy Equivalent
                    </h4>
                    <p className="text-secondary mb-0">
                      Instead of focusing on "weight loss", we use the concept of "fat energy equivalent". This focuses on energy science rather than just weight numbers.
                    </p>
                  </div>
                </div>

                <div className="col-md-4 mb-4">
                  <div className="p-4 h-100 bg-light rounded">
                    <h4 className="fs-5 mb-3 d-flex align-items-center">
                      <span className="text-success me-2">●</span>
                      Positive Habits
                    </h4>
                    <p className="text-secondary mb-0">
                      By tracking only workout calories, we help you create a caloric deficit through activity, without obsessing over every food choice.
                    </p>
                  </div>
                </div>
              </div>

              <div className="card shadow-sm border-0 mb-4">
                <div className="card-body p-4">
                  <h4 className="fw-bold fs-5 mb-3">Why Workouts Only?</h4>
                  <div className="row">
                    <div className="col-md-6">
                      <ul className="list-unstyled">
                        <li className="mb-2 d-flex">
                          <span className="text-primary me-2">✓</span>
                          <span>Build consistent exercise habits</span>
                        </li>
                        <li className="mb-2 d-flex">
                          <span className="text-primary me-2">✓</span>
                          <span>Create deficit through activity, not restriction</span>
                        </li>
                      </ul>
                    </div>
                    <div className="col-md-6">
                      <ul className="list-unstyled">
                        <li className="mb-2 d-flex">
                          <span className="text-primary me-2">✓</span>
                          <span>Maintain a healthier relationship with food</span>
                        </li>
                        <li className="mb-2 d-flex">
                          <span className="text-primary me-2">✓</span>
                          <span>Focus on what you're adding to your life</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>

      {/* Download Section */}
      <section id="download" className="py-5 bg-primary bg-opacity-10">
        <div className="container py-5 text-center">
          <h2 className="display-5 fw-bold mb-4">
            Ready to change your approach to fitness?
          </h2>
          <p className="lead mb-5 mx-auto" style={{ maxWidth: '700px' }}>
            Download AimFit and start focusing on what you're adding to your life, not what you're taking away.
          </p>
          <a
            href="https://apps.apple.com/pl/app/aimfit/id6743213520"
            className="btn btn-lg btn-dark d-inline-flex align-items-center px-4 py-3"
            target="_blank"
            rel="noopener noreferrer"
          >
            <svg width="30" height="30" className="me-2" viewBox="0 0 24 24" fill="currentColor">
              <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
            </svg>
            Download on App Store
          </a>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-light py-4">
        <div className="container d-flex flex-column flex-md-row justify-content-between align-items-center">
          <div className="mb-3 mb-md-0">
            <span
              className="fs-4 text-primary"
              style={{ fontFamily: "'Nunito', sans-serif", fontWeight: 800 }}
            >
              Aim
            </span>
            <span
              className="fs-4 text-warning"
              style={{ fontFamily: "'Nunito', sans-serif", fontWeight: 800 }}
            >
              Fit
            </span>
          </div>
          <div className="d-flex align-items-center gap-4">
            <a href="/privacy-policy" className="text-secondary small text-decoration-none">Privacy Policy</a>
            <div className="text-secondary small">
              &copy; {new Date().getFullYear()} AimFit. All rights reserved.
            </div>
          </div>
        </div>
      </footer>

      {/* Bootstrap Icons */}
      <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.10.0/font/bootstrap-icons.css" />
    </div>
  );
}

export default EnhancedLandingPage;